import { useContext, useMemo, type FC } from 'react';
import { useSelector } from 'react-redux';
import { PapiUser } from '@wix/da-papi-types';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { getVideoCreatorRestrictions } from '../../../selectors/studio';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';

import s from './CoreBannerMobile.scss';

export interface Props {
  currentUser?: PapiUser;
}

const CoreBannerMobile: FC<Props> = ({ currentUser }) => {
  const { t } = useTranslation();
  const { hasCoreMembership } = useContext(SessionContext);
  const { videoPromptsRemaining } = useSelector(getVideoCreatorRestrictions);
  const nonCoreNoPrompts = useMemo(() => {
    if (!hasCoreMembership) {
      return videoPromptsRemaining < 1;
    } else {
      return false;
    }
  }, [hasCoreMembership, videoPromptsRemaining]);

  if (!nonCoreNoPrompts) {
    return null;
  }

  return (
    <div className={s['root']}>
      <div className={s['upsell-text']}>
        <div className={s['upsell-text-1']}>{t('studio.videoCreator.mobileCoreBanner.text')}</div>
        <div className={s['upsell-text-2']}>{t('studio.videoCreator.mobileCoreBanner.text2')}</div>
      </div>
      <BrandedButton
        size="small"
        variant="core-orange"
        className={s['core-upgrade-button']}
        href={Url.coreMembershipLink({ referer: Url.videoCreatorLink() })}
        target="_blank"
        biData={BiData<BuyCoreButtonBiEvent>({
          evid: 375,
          referral_info: ReferralType.VIDEO_CREATOR_BANNER_NO_PROMPTS,
        })}
      >
        {t('studio.videoCreator.button.getCore')}
      </BrandedButton>
    </div>
  );
};

CoreBannerMobile.displayName = 'CoreBannerMobile';
export default CoreBannerMobile;
